import { currentReceipts, waiverText } from './helpers';

/**
 * The Receipts column: a read-only badge ("No receipt", "1 receipt",
 * "3 receipts"). The row's Receipts button opens the dialog.
 */
const ReceiptCell = ({ expense }) => {
  const receipts = currentReceipts(expense);
  if (!receipts.length) {
    return (
      <td className="text-nowrap">
        <span className="badge text-bg-danger" title={waiverText(expense) || 'No receipt attached'}>
          No receipt
        </span>
      </td>
    );
  }
  return (
    <td className="text-nowrap">
      <span className="badge text-bg-light border" title={receipts.map((r) => r.filename).join(', ')}>
        <i className="bi bi-paperclip me-1" aria-hidden="true"></i>
        {receipts.length === 1 ? '1 receipt' : `${receipts.length} receipts`}
      </span>
    </td>
  );
};

export default ReceiptCell;
